import Vue from 'vue'

export default {
  list: async (period) => {
    return Vue.axios.get(`/indicators/${period}`);
  },
  indicator: async (id) => {
    return Vue.axios.get('/indicators/' + id);
  },
  fields: async (id) => {
    return Vue.axios.get('/indicators/' + id + '/fields');
  },
  save: async (indicator, period) => {
    let formData = new FormData()
    for (const prop in indicator) if (indicator.hasOwnProperty(prop)) {
      formData.append('indicator[' + prop + ']', indicator[prop])
    }
    return Vue.axios.post(`/indicators/${period}`, formData);
  },
  saveAward: (period, indicator, award) => {
    let formData = new FormData();
    formData.append('indicator', indicator.id);
    formData.append('award', award);

    return Vue.axios.post('/indicators/award', formData);
  },
  saveField: async (indicator, field) => {
    let formData = new FormData()
    for (const prop in field) if (field.hasOwnProperty(prop)) {
      if (field[prop] instanceof Array) {

        field[prop].forEach((item, index) => {
          for(const i in item) if (item.hasOwnProperty(i)) {
            formData.append('field[' + prop + '][' + index + '][' + i + ']', item[i])
          }
        })
      } else {
        formData.append('field[' + prop + ']', field[prop])
      }
    }

    return Vue.axios.post('/indicators/' + indicator.id + '/fields', formData);
  },
  async calculateSummaryReportTeachers (period, indicators, institutions, department) {
    const formData = new FormData()
    indicators.forEach(indicator => {
      formData.append('indicators[]', indicator)
    })
    formData.append('institutions', institutions)
    if (department) {
      formData.append('department', department)
    }
    return Vue.axios.post('/reports/'+period+'/summary-teachers', formData, {
      responseType: 'blob'
    })
  },
  async calculateSummaryReportDepartment (period, indicators, institutions, department) {
    const formData = new FormData()
    indicators.forEach(indicator => {
      for (const prop in indicator) if (indicator.hasOwnProperty(prop)) {
        formData.append(`indicators[${indicator.sequence}][${prop}]`, indicator[prop])
      }
    })
    formData.append('institutions', institutions)
    if (department) {
      formData.append('department', department)
    }
    return Vue.axios.post('/reports/'+period+'/summary-department', formData, {
      responseType: 'blob'
    })
  },
  async calculateNotCountedReport (period) {
    return Vue.axios.get(`/reports/${period}/not-counted`, {
      responseType: 'blob'
    })
  }
}

function Indicator(id, title_ru, title_kz, award, planned, kpi, single, unit_ru, unit_kz, description_ru, description_kz, category, parent) {
  if (id instanceof Object) {
    ({ id, title_ru, title_kz, award, planned, kpi, single, unit_ru, unit_kz, description_ru, description_kz, category, parent } = id)
  }
  this.id = id || ''
  this.title_ru = title_ru || ''
  this.title_kz = title_kz || ''
  this.award = award || 0
  this.planned = (planned !== undefined) ? planned : true
  this.kpi = (kpi !== undefined) ? kpi : true
  this.single = (single !== undefined) ? single : false
  this.unit_ru = unit_ru || ''
  this.unit_kz = unit_kz || ''
  this.description_ru = description_ru || ''
  this.description_kz = description_kz || ''
  this.category = category || ''
  this.parent = parent || ''
}
function IndicatorField(id, title_ru, title_kz, type, enums, required, listed) {
  if (id instanceof Object) {
    ({id, title_ru, title_kz, type, enums, required, listed} = id)
  }
  this.id = id || ''
  this.title_ru = title_ru || ''
  this.title_kz = title_kz || ''
  this.type = type || ''
  this.enums = enums || []
  this.required = required || false
  this.listed = listed || true
}
function IndicatorFieldEnum(id, value, award) {
  if (id instanceof Object) {
    ({id, value, award} = id)
  }
  this.id = id || ''
  this.value = value || ''
  this.award = award || 0
}

function IndicatorValue(id, period, indicator, values) {
  if (id instanceof Object) {
    ({id, period, indicator, values} = id)
  }
  this.id = id || ''
  this.period = period || ''
  this.indicator = indicator || new Indicator()
  this.values = values || {}
}

export { Indicator, IndicatorField, IndicatorFieldEnum, IndicatorValue }
